module.exports = __webpack_public_path__ + "reportlabSlideoutAsset.034993bfd6e2a20dbc4045e967669ab9.png";